/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ReplacementInputs */



/**
* | output |
* | --- |
* | "Replacement" |
*
* @param {ReplacementInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const replacement = /** @type {((inputs?: ReplacementInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ReplacementInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Remplacement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ersatz")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sostituzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Замена")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reemplazo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("替代品")
	if (locale === "ja") return /** @type {LocalizedString} */ ("交換")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिस्थापन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Substituição")
	return /** @type {LocalizedString} */ ("Replacement")
});